import { render } from "./company-basic.vue?vue&type=template&id=9de16d3e&scoped=true"
import script from "./company-basic.vue?vue&type=script&lang=js"
export * from "./company-basic.vue?vue&type=script&lang=js"

import "./company-basic.vue?vue&type=style&index=0&id=9de16d3e&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9de16d3e"]])

export default __exports__